// frontend/src/pages/NotFoundPage.tsx
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { AlertTriangle, Home } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-10rem)] bg-background text-center px-4 py-12 text-foreground">
      {/* Icon - Using 'destructive' color for emphasis on an error/alert status */}
      <AlertTriangle className="h-24 w-24 text-destructive/80 mb-8" />

      {/* "404" Heading - Using 'destructive' color */}
      <h1 className="text-5xl md:text-6xl font-bold text-destructive mb-4">
        404
      </h1>

      {/* Sub-heading */}
      <h2 className="text-2xl md:text-3xl font-semibold text-foreground mb-6">
        Oops! Page Not Found.
      </h2>

      {/* Descriptive Paragraph - 'text-muted-foreground' is already a theme color */}
      <p className="text-lg text-muted-foreground max-w-md mx-auto mb-10">
        The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
      </p>

      {/* "Go Back to Homepage" Button - Themed with gradient and !important fix */}
      <Button
        asChild
        size="lg"
        className="!bg-gradient-to-r !from-primary !to-accent hover:!from-primary/90 hover:!to-accent/90 text-primary-foreground shadow-lg hover:shadow-xl transition-all duration-300"
      >
        <Link to="/">
          <Home className="mr-2 h-5 w-5" /> Go Back to Homepage
        </Link>
      </Button>
    </div>
  );
};

export default NotFoundPage;